<ng-template [ngIf]="service.IsFeatureEnabled">
  <div *ngIf="hasBeenAnalyzed || isLoading" fxLayout='row' fxLayoutAlign='center center' >
    <dx-load-indicator [visible]="isLoading" height="18" width="18"></dx-load-indicator>
    <div *ngIf="hasBeenAnalyzed" style='width: 100px;height:15px!important;line-height: .45 !important' class='ocl-status-blue'>
      INTERPRETATION
    </div>
  </div>
</ng-template>
